import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

const toDateParam = (date) => (date ? date.toISOString().split('T')[0] : null);

export const fetchAteSwVersions = async () => {
    const response = await axios.get(`${API_BASE}/api/ate-sw-versions`);
    return response.data || [];
};

export const fetchStepNumbers = async () => {
    const response = await axios.get(`${API_BASE}/api/distinct-step-numbers`);
    return (response.data || []).map((step) => ({ value: step, label: `Step ${step}` }));
};

export const fetchTestspecs = async () => {
    const response = await axios.get(`${API_BASE}/api/testspecs`);
    return response.data || [];
};

export const fetchStepFrequency = async ({
    startDate,
    endDate,
    ateSwVersion,
    selectedStepNumbers,
    selectedFamilies = [],
    selectedTestspec = '',
}) => {
    const response = await axios.get(`${API_BASE}/api/step-frequency`, {
        params: {
            startDate: toDateParam(startDate),
            endDate: toDateParam(endDate),
            ateSwVersion: ateSwVersion || undefined,
            Testspec: selectedTestspec || undefined,
            stepNumbers: selectedStepNumbers.length
                ? selectedStepNumbers.map((item) => item.value)
                : undefined,
            selectedFamilies: selectedFamilies.join(',') || undefined,
        },
    });

    return response.data || [];
};
